import React, { Component } from "react";
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "react-awesome-slider/dist/styles.css";
import "./black.css";
import DashAnalytics from "../../assets/banners/courses/dashboardAnalytics/PC_Carrosel_DASHBOARD_E_ANALYTICS.png";
import DashAnalyticsMob from "../../assets/banners/courses/dashboardAnalytics/Mobile_Carrosel_DASHBOARD_E_ANALYTICS.png";
import IntelCyber from "../../assets/banners/courses/Intel_em_Cybersecurity/PC_Carrosel_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-08.png";
import IntelCyberMob from "../../assets/banners/courses/Intel_em_Cybersecurity/Mobile_Carrosel_INTELIGENCIA_EM_CYBERSECURITY_COM_SOLUCOES_OPEN_SOURCE-11.png";
import NoSql from "../../assets/banners/courses/NoSQL/PC_Carrosel_NOSQL.png";
import NoSqlMob from "../../assets/banners/courses/NoSQL/Mobile_Carrosel_NOSQL.png";
import Storytelling from "../../assets/banners/courses/Storytelling/Banner_storytelling_e_ux.png";
import StorytellingMob from "../../assets/banners/courses/Storytelling/Mobile_storytelling_e_ux.png";
import Apigat from "../../assets/banners/courses/APIGATEWAY/PC_Carrosel_API_GATEWAY.png";
import ApigatMob from "../../assets/banners/courses/APIGATEWAY/Mobile_Carrosel_API_GATEWAY.png";
import bigdata from "../../assets/banners/courses/bigData_Mining/PC_Carrosel_BIG_DATA_E_DATA_MINING.png";
import bigdataMob from "../../assets/banners/courses/bigData_Mining/Mobile_Carrosel_BIG_DATA_E_DATA_MINING.png";
import Simplefooter from "../footer/simplefooter";
import arqNegocios from "../../assets/banners/courses/arquitetodenegocios/bannerarq.png";
import arqNegociosMob from "../../assets/banners/courses/arquitetodenegocios/arqmob.png";
import gif from "../../assets/banners/gifHome/gif_carrosel.gif";
import gif2 from "../../assets/banners/gifHome/gif2.gif";
import blackFriday10 from "../../assets/blackfriday/bannerBlackFriday10.png";
import blackFriday10Mob from "../../assets/blackfriday/bannerBlackFriday10Mob.png";



// import cursoVerao from "../../assets/banners/banner_cursos_de_verao.png";
// import cursoVeraoMob from "../../assets/banners/curso-de-verao-mobile.png";

// import ValentinesDay from "../../assets/banners/banner_valentines_day.png";
// import ValentinesDayMob from "../../assets/banners/banner_valentines_day_mobile.png";

export default class Blog extends Component {
  onCourseClick(selectedCourse, courseIndex) {
    if (
      courseIndex === 12 ||
      courseIndex === 13 ||
      courseIndex === 14 ||
      courseIndex === 15 ||
      courseIndex === 16 ||
      courseIndex === 17 ||
      courseIndex === 20 ||
      courseIndex === 21 ||
      courseIndex === 22 ||
      courseIndex === 23 ||
      courseIndex === 24 ||
      courseIndex === 25 ||
      courseIndex === 27 ||
      courseIndex === 28 ||
      courseIndex === 29 ||
      courseIndex === 30 ||
      courseIndex === 41 
    ) {
      return this.props.history.push({
        pathname: `/calendar/${courseIndex}/${selectedCourse}`
      });
    } else
      return this.props.history.push({
        pathname: `/workshop-page/${courseIndex}/${selectedCourse}`
      });
  }

  goToOfertas() {
    return this.props.history.push({
      pathname: `/valentines-day`
    });
  }

  render() {
    const AutoplaySlider = withAutoplay(AwesomeSlider);
    // function onLink(url) {
    //   window.open(url)
    // }
    var width = window.innerWidth;
    const slider = (
      <AutoplaySlider
        play={true}
        organicArrows={true}
        cancelOnInteraction={true} // should stop playing on user interaction
        interval={4000}
        buttons={true}
        bullets={true}
        style={{ width: "100%", height: "100%" }}
      >
        {/* {width > 700 ? (
          <div
            data-src={Natal}
            onClick={() => this.goToOfertas()}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={Natal}
            onClick={() => this.goToOfertas()}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )} */}

        {/* {width > 700 ? (
          <div
            data-src={Natal}
            onClick={() => this.goToOfertas()}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={Natal}
            onClick={() => this.goToOfertas()}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )} */}

        {/* {width > 700 ? (
          <div
            data-src={cursoVerao}
            onClick={() => this.goToOfertas()}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={cursoVeraoMob}
            onClick={() => this.goToOfertas()}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )} */}

        {/* {width > 700 ? (
          <div
            data-src={cursoVerao}
            onClick={() => this.goToOfertas()}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={cursoVeraoMob}
            onClick={() => this.goToOfertas()}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )} */}

        {/* {width > 700 ? (
          <div
            data-src={ValentinesDay}
            onClick={() => this.goToOfertas()}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={ValentinesDayMob}
            onClick={() => this.goToOfertas()}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )} */}

        {width > 700 ? (
          <div
            data-src={gif2}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={gif}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={gif}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={gif}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={arqNegocios}
            onClick={() => this.onCourseClick("C48", 48)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={arqNegociosMob}
            onClick={() => this.onCourseClick("C48", 48)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={DashAnalytics}
            onClick={() => this.onCourseClick("C21", 21)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={DashAnalyticsMob}
            onClick={() => this.onCourseClick("C21", 21)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={IntelCyber}
            onClick={() => this.onCourseClick("C25", 25)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={IntelCyberMob}
            onClick={() => this.onCourseClick("C25", 25)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={NoSql}
            onClick={() => this.onCourseClick("C26", 26)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={NoSqlMob}
            onClick={() => this.onCourseClick("C26", 26)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={Storytelling}
            onClick={() => this.onCourseClick("C27", 27)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={StorytellingMob}
            onClick={() => this.onCourseClick("C27", 27)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={Apigat}
            onClick={() => this.onCourseClick("C28", 28)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={ApigatMob}
            onClick={() => this.onCourseClick("C28", 28)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {width > 700 ? (
          <div
            data-src={bigdata}
            onClick={() => this.onCourseClick("C41", 41)}
            style={{ width: "100%", height: "100%" }}
          ></div>
        ) : (
          <div
            data-src={bigdataMob}
            onClick={() => this.onCourseClick("C41", 41)}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )}

        {/* {width > 700 ? (
          <div
            data-src={blackFriday10}
            onClick={() => window.open('https://www.sympla.com.br/produtor/hitbra', '_self')}
            style={{ width: "100%", height: "100%" }}
          >
          </div>
        ) : (
          <div
            data-src={blackFriday10Mob}
            onClick={() => window.open('https://www.sympla.com.br/produtor/hitbra', '_self')}
            style={{ width: "100vw", height: "100%" }}
          ></div>
        )} */}
      </AutoplaySlider>
    );

    return (
      <div className="fullWidthContainer fullHeight clear">
        <div style={{ width: "100vw", marginTop: "6rem" }}>{slider}</div>
        <div class="contact-simplefooter">
          <div className="footer-father">
            <Simplefooter />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/home/home.js